import React from "react";
import PropTypes from "prop-types";

//icons
import { FiChevronRight } from "react-icons/fi";

//components
import AnchorLink from "../../AnchorLink";

const propTypes = {
  content: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  gridClass: PropTypes.string,
  isReadMore: PropTypes.bool,
};

const InfoSectionLeft = ({ content, className, gridClass, isReadMore }) => {
  return (
    <>
      <section className={["info-wrapper-left", className].join(" ")}>
        <div className="container">
          <div className={["info-grid-left", gridClass].join(" ")}>
            <div className="info-grid-left-details-box text-justify">
              <h1 className="info-grid-left-title">{content.left.title}</h1>
              <div className="info-grid-left-desc m-t-10">{content.left.description}</div>
              {isReadMore && (
                <AnchorLink href="/" className="theme-button">
                  Read More <FiChevronRight className="icon" />
                </AnchorLink>
              )}
            </div>
            <div className="info-grid-left-img-box">
              <img
                className="info-grid-left-img"
                src={content.left.images.items[0].imgSrc}
                alt={content.left.images.items[0].alt}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const defaultProps = {
  className: "",
  gridClass: "",
  isReadMore: false,
};
InfoSectionLeft.propTypes = propTypes;
InfoSectionLeft.defaultProps = defaultProps;

export default InfoSectionLeft;
